// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../node_modules/rescript/lib/es6/array.js";
import * as React from "react";
import * as Belt_List from "../../../../../../node_modules/rescript/lib/es6/belt_List.js";

function SuspensionDaysRowCmp(Props) {
  var table_details = Props.table_details;
  var action_value = Props.action_value;
  return React.createElement("tr", {
              className: "suspension-days-row"
            }, React.createElement("td", {
                  className: "suspension-days-header"
                }, table_details.suspension_days_text), $$Array.of_list(Belt_List.map(action_value, (function (value) {
                        return React.createElement("td", {
                                    className: "threshold"
                                  }, React.createElement("div", {
                                        className: "threshold-content"
                                      }, value));
                      }))));
}

var make = SuspensionDaysRowCmp;

export {
  make ,
  
}
/* react Not a pure module */
